import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { formatProfileDate } from '../utils/format-date';
import { PasswordChangeForm } from './PasswordChangeForm';

interface PasswordChangeCardProps {
  passwordChangedAt: string | null;
}

// PRD §3.4 Card 2 — collapsed by default with the "Last Changed" subtitle
// and a [변경] toggle that mirrors the phone-change toggle pattern.
export function PasswordChangeCard({ passwordChangedAt }: PasswordChangeCardProps) {
  const { t } = useTranslation('my-profile');
  const [expanded, setExpanded] = useState(false);

  const lastChangedLabel = passwordChangedAt
    ? t('cards.password.lastChanged', { date: formatProfileDate(passwordChangedAt) })
    : t('cards.password.lastChangedNever');

  return (
    <section className="card" style={{ padding: 24 }} aria-labelledby="mp-password-heading">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <h2
            id="mp-password-heading"
            style={{ fontSize: 16, fontWeight: 600, margin: '0 0 4px 0' }}
          >
            {t('cards.password.title')}
          </h2>
          <p style={{ fontSize: 13, color: 'var(--muted-foreground)', margin: 0 }}>
            {lastChangedLabel}
          </p>
        </div>
        <button
          type="button"
          className={`btn btn-default ${expanded ? 'btn-secondary' : 'btn-outline'}`}
          style={{ height: 40, minWidth: 80, fontWeight: 500 }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded
            ? t('passwordChange.toggle.cancel')
            : t('passwordChange.toggle.edit')}
        </button>
      </div>

      {expanded && <PasswordChangeForm onSaved={() => setExpanded(false)} />}
    </section>
  );
}
